/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import { SignInProps, HeaderProps } from "./components";

const is = require("is_js");

const SERVICE_NAME = "SignInPageService";
const log: any = LoggerModule.getInstance();

export class SignInPageService {
  private static instance: SignInPageService;
  private vapp: VApplication;
  private readonly loginRestAPI: string;
  private readonly headers: HeaderProps;
  private readonly signerPK: string;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
    this.loginRestAPI = props?.loginRestAPI;
    this.headers = props?.headers;
    this.signerPK = props.signerPK;
  }

  public static getInstance(props: any = {}): SignInPageService {
    if (!SignInPageService.instance) {
      SignInPageService.instance = new SignInPageService(props);
    }
    return SignInPageService.instance;
  }

  public async signInUser(args: SignInProps) {
    let _args = {
      ...args,
      apiURL: this.loginRestAPI,
      headers: this.headers,
    };
    const agent = getAgent();
    return agent.signInUser(_args);
  }

  public async sendOTP(args: { email: string }) {
    let _args = {
      ...args,
      apiURL: this.loginRestAPI,
      headers: this.headers,
    };
    const agent = getAgent();
    return agent.sendOTP(_args);
  }

  public async getSignInType(args: { email: string }) {
    let _args = {
      ...args,
      apiURL: this.loginRestAPI,
      headers: this.headers,
    };
    const agent = getAgent();
    return agent.getSignInType(_args);
  }

  public async getAccessToken(args: { role: string; jwtToken: string }) {
    let _args = {
      ...args,
      apiURL: this.loginRestAPI,
      headers: this.headers,
    };
    const agent = getAgent();
    return agent.getAccessToken(_args);
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();
    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getPageContent() {
    let content: any = {};
    let compProps: any = null;

    const agent = getAgent();
    const { token, decoded } = await agent?.parseAndDecodeToken({
      signerPK: this.signerPK,
    });
    content = {
      ...content,
      initialData: {
        email: decoded?.email,
      },
      token: token,
    };
    return content;
  }
}
